import baseUrl from "./baseUrl";

const INVENTORY = "client/inventory";

// --- Category ---

export function findAllCategory(): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/category/findAllCategory`)
    .then((response) => response.data.data);
}

export function findCategoryById(categoryId: string): Promise<unknown> {
  return baseUrl
    .get<{ data: unknown }>(`${INVENTORY}/category/findCategoryById`, {
      headers: { categoryid: categoryId },
    })
    .then((response) => response.data.data);
}

export function createCategory(data: { categoryName: string }): Promise<void> {
  return baseUrl
    .post(`${INVENTORY}/category/createCategory`, data)
    .then(() => undefined);
}

export function updateCategoryById(
  categoryId: string,
  data: { categoryName: string }
): Promise<void> {
  return baseUrl
    .patch(`${INVENTORY}/category/updateCategoryById`, data, {
      headers: { categoryid: categoryId },
    })
    .then(() => undefined);
}

// --- Sub Category ---

export function findAllSubCategory(): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/subCategory/findAllSubCategory`)
    .then((response) => response.data.data);
}

export function findSubCategoryById(subCategoryId: string): Promise<unknown> {
  return baseUrl
    .get<{ data: unknown }>(`${INVENTORY}/subCategory/findSubCategoryById`, {
      headers: { subcategoryid: subCategoryId },
    })
    .then((response) => response.data.data);
}

export function createSubCategory(data: {
  subCategoryName: string;
  categoryId: string;
}): Promise<void> {
  return baseUrl
    .post(`${INVENTORY}/subCategory/createSubCategory`, data)
    .then(() => undefined);
}

export function updateSubCategoryById(
  subCategoryId: string,
  data: { subCategoryName: string; categoryId: string }
): Promise<void> {
  return baseUrl
    .patch(`${INVENTORY}/subCategory/updateSubCategoryById`, data, {
      headers: { subcategoryid: subCategoryId },
    })
    .then(() => undefined);
}

// --- Brand ---

export function findAllBrand(): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/brand/findAllBrand`)
    .then((response) => response.data.data);
}

export function findBrandById(brandId: string): Promise<unknown> {
  return baseUrl
    .get<{ data: unknown }>(`${INVENTORY}/brand/findBrandById`, {
      headers: { brandid: brandId },
    })
    .then((response) => response.data.data);
}

export function createBrand(data: { brandName: string }): Promise<void> {
  return baseUrl
    .post(`${INVENTORY}/brand/createBrand`, data)
    .then(() => undefined);
}

export function updateBrandById(
  brandId: string,
  data: { brandName: string }
): Promise<void> {
  return baseUrl
    .patch(`${INVENTORY}/brand/updateBrandById`, data, {
      headers: { brandid: brandId },
    })
    .then(() => undefined);
}

// --- Scale ---

export function findAllScale(): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/scale/findAllScale`)
    .then((response) => response.data.data);
}

export function createScale(data: {
  scale: string;
  unit: string;
}): Promise<void> {
  return baseUrl
    .post(`${INVENTORY}/scale/createScale`, data)
    .then(() => undefined);
}

// --- Product ---

export function findAllProduct(): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/product/findAllProduct`)
    .then((response) => response.data.data);
}

export function searchProductBrands(keyword: string): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/product/searchAllBrand`, {
      headers: { keyword },
    })
    .then((response) => response.data.data);
}

export function searchProductCategories(keyword: string): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/product/searchAllCategory`, {
      headers: { keyword },
    })
    .then((response) => response.data.data);
}

export function searchProductSubCategories(
  keyword: string,
  categoryId?: string
): Promise<unknown[]> {
  const headers: Record<string, string> = { keyword };
  if (categoryId) {
    headers.categoryid = categoryId;
  }
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/product/searchAllSubCategory`, {
      headers,
    })
    .then((response) => response.data.data);
}

export function findProductById(productId: string): Promise<unknown> {
  return baseUrl
    .get<{ data: unknown }>(`${INVENTORY}/product/findProductById`, {
      headers: { productid: productId },
    })
    .then((response) => response.data.data);
}

export function createProduct(data: unknown): Promise<void> {
  return baseUrl
    .post(`${INVENTORY}/product/createProduct`, data)
    .then(() => undefined);
}

export function updateProductPriceById(
  productId: string,
  data: unknown
): Promise<void> {
  return baseUrl
    .patch(`${INVENTORY}/product/updateProductPriceById`, data, {
      headers: { productid: productId },
    })
    .then(() => undefined);
}

// --- Supplier ---

export function findAllSupplier(): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/supplier/findAllSupplier`)
    .then((response) => response.data.data);
}

export function findSupplierById(supplierId: string): Promise<unknown> {
  return baseUrl
    .get<{ data: unknown }>(`${INVENTORY}/supplier/findSupplierById`, {
      headers: { supplierid: supplierId },
    })
    .then((response) => response.data.data);
}

export function createSupplier(data: unknown): Promise<void> {
  return baseUrl
    .post(`${INVENTORY}/supplier/createSupplier`, data)
    .then(() => undefined);
}

export function updateSupplierById(
  supplierId: string,
  data: unknown
): Promise<void> {
  return baseUrl
    .patch(`${INVENTORY}/supplier/updateSupplierById`, data, {
      headers: { supplierid: supplierId },
    })
    .then(() => undefined);
}

// --- Purchase ---

export function findAllPurchase(): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/purchase/findAllPurchase`)
    .then((response) => response.data.data);
}

export function searchPurchaseSuppliers(keyword: string): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/purchase/searchAllSupplier`, {
      headers: { keyword },
    })
    .then((response) => response.data.data);
}

export function findPurchaseById(purchaseId: string): Promise<unknown> {
  return baseUrl
    .get<{ data: unknown }>(`${INVENTORY}/purchase/findPurchaseById`, {
      headers: { purchaseid: purchaseId },
    })
    .then((response) => response.data.data);
}

export function searchPurchaseProducts(keyword: string): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/purchase/searchAllProduct`, {
      headers: { keyword },
    })
    .then((response) => response.data.data);
}

export function createPurchase(data: unknown): Promise<void> {
  return baseUrl
    .post(`${INVENTORY}/purchase/createPurchase`, data)
    .then(() => undefined);
}

export function updatePurchase(
  purchaseId: string,
  data: unknown
): Promise<void> {
  return baseUrl
    .patch(`${INVENTORY}/purchase/updatePurchase`, data, {
      headers: { purchaseid: purchaseId },
    })
    .then(() => undefined);
}

// --- Release ---

export function findAllRelease(type: string): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/release/findAllRelease`, {
      headers: { type },
    })
    .then((response) => response.data.data);
}

export function searchReleaseEmployees(keyword: string): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/release/searchAllEmployees`, {
      headers: { keyword },
    })
    .then((response) => response.data.data);
}

export async function searchReleasePatients(
  keyword: string
): Promise<unknown[]> {
  const response = await baseUrl.get<{ data: unknown[] }>(
    `${INVENTORY}/release/searchAllPatients`,
    { headers: { keyword } }
  );
  return response.data.data;
}

export function searchProductForRelease(keyword: string): Promise<unknown[]> {
  return baseUrl
    .get<{ data: unknown[] }>(`${INVENTORY}/release/searchProductForRelease`, {
      headers: { keyword },
    })
    .then((response) => response.data.data);
}

export function employeeProductRelease(data: unknown): Promise<void> {
  return baseUrl
    .post(`${INVENTORY}/release/employeeProductRelease`, data)
    .then(() => undefined);
}

export function patientsProductRelease(data: unknown): Promise<void> {
  return baseUrl
    .post(`${INVENTORY}/release/patientsProductRelease`, data)
    .then(() => undefined);
}
